import { render, staticRenderFns } from "./SalesReallocationDetail.vue?vue&type=template&id=3c5abc1d&scoped=true&"
import script from "./SalesReallocationDetail.vue?vue&type=script&lang=js&"
export * from "./SalesReallocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesReallocationDetail.vue?vue&type=style&index=0&id=3c5abc1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5abc1d",
  null
  
)

export default component.exports